const sharedMobileDesktop = require('../pages/content/integration_EN.js');

export default {
  large: [
    {
      name: 'New Customer Details',

      fixedSection: {
        sectionType: 'toc',
        data: {
          headline: 'New customer',
          // index: 1,
          paging: false,
        },
      },

      scrolledSection: {
        sectionType: 'integrationform',
        data: {
          mailto: sharedMobileDesktop.mailto,
          email: '',
          subject: '',
          name: '',
          message: '',
          ...sharedMobileDesktop
        },
      },

    }
  ],
};



// WEBPACK FOOTER //
// ./pages/Newcustomer.js